/**
 * Class to handle custom-element
 * Add/Remove/Update cart with free item
 */
class CartFreeItem extends HTMLElement {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.onChange = debounce(this.onChange, 500, true);
    this.elForm = this.querySelector('form');
    this.currentFreeItemIndex = parseInt(this.dataset.currentFreeItemIndex);
    const isEnable = this.dataset.isEnable === 'true';
    this.addEventListener('change', this.onChange);
    // On load Custom element remove current free Item because doesn't fill in requirement (eg: mini amount)
    if (!isEnable && this.currentFreeItemIndex > 0) this.removeFromCart();
  }

  /**
   * Debounce callback function
   * Trigger after change select value
   * @returns {Promise<void>}
   */
  async onChange() {
    if (this.currentFreeItemIndex) await this.removeFromCart();
    this.addToCart();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.js-cart-icon'
      }
    ];
  }

  /**
   * Call on load or after select value change and currentFreeItemIndex is different from 0
   * @param updateContent {boolean} - In some case we don't want to update the cart content DOM
   * @returns {Promise<unknown>}
   */
  removeFromCart(updateContent= true) {
    this.enableLoading();
    const elLine = document.getElementById(`CartItem-${this.currentFreeItemIndex}`)
    if (!!elLine) elLine.classList.add('u-none') // hide before remove it from cart
    const body = JSON.stringify({
      line: this.currentFreeItemIndex,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    return new Promise(resolve => {
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (updateContent) {
          this.renderContents(response)
          this.disableLoading()
        }
        resolve(response)
        return response
      })
    })
  }

  addToCart() {
    this.enableLoading()
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.elForm);

    formData.append('sections_url', window.location.pathname);
    formData.append('sections', this.getSectionsToRender().map((section) => section.section));
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      this.renderContents(response)
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.disableLoading()
    });
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      if (!!section.section) {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }
    }));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    const loader = this.querySelector('.loading-overlay__spinner') || document.querySelector('.loading-overlay__spinner');
    document.activeElement.blur();
    if(loader) loader.classList.remove('hidden')
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    const loader = this.querySelector('.loading-overlay__spinner') || document.querySelector('.loading-overlay__spinner');
    if(loader) loader.classList.add('hidden')
  }
}

customElements.define('cart-free-item', CartFreeItem);
